<template>
  <div class="c_table_wrap">
    큐레이터 디테일 레이아웃
    <div>
      <button @click="$router.back()">목록</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "MemberDetailCuratorLayout",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
  },
  data() {
    return{

    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {

  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>